import Pfizer from "./Pfizer";

export default Pfizer;